import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import DocumentReminderPanel from "./DocumentReminderPanel";
import moment from "moment";
import DocumentReminderRowCard from "./DocumentReminderCard";
import { Reminder } from "./models";

interface Props {
  document: server.dto.ESignDocument;
  initialReminders: server.dto.DocumentReminder[]
}

export const DocumentReminderApp = (props: Props) => {
  const remindersQuery = useCustomQuery({
    queryKey: ["document-reminders", props.document.documentId],
    queryFn: () => window.CoreApi.ESign.ListReminders(props.document.documentId).then(r => r.data.data),
    initialData: props.initialReminders,
  });

  const deleteAllReminders = () => window.CoreApi.ESign.DeleteAllReminders(props.document.documentId);

  const addReminder = (days: number) => window.CoreApi.ESign.AddReminder({
    documentId: props.document.documentId,
    daysAfterSendDate: days,
  });

  const updateReminder = (days: number, reminderNr: number) => window.CoreApi.ESign.UpdateReminder({
    documentId: props.document.documentId,
    daysAfterSendDate: days,
    type: ("reminder" + reminderNr) as server.dto.DocumentReminderTypes,
  });

  const clearLastReminder = () => window.CoreApi.ESign.DeleteLastReminder(props.document.documentId)


  const sendMoment = (props.document.lifeCycle.value === "draft" || props.document.lifeCycle.value === "review")
    ? moment.utc().startOf("day")
    : moment.utc(props.document.sendDate);
  const canClearAll = props.document.lifeCycle.value !== "completed" && remindersQuery.data.some(reminder => !reminder.isSent);
  const canDisplayAddNewReminder = props.document.lifeCycle.value !== "completed" && remindersQuery.data.length < serverReference.constants.eSign.maxReminders

  const reminders = remindersQuery.data.map<Reminder>(reminder => ({
    days: reminder.daysAfterSendDate,
    reminderNr: reminder.type.number,
    isSent: reminder.isSent,
  }));


  return <DocumentReminderPanel
    maxDaysAfterSendDate={serverReference.constants.eSign.maxReminderInterval}
    documentSendMoment={sendMoment}
    reminders={reminders}
    clearLastReminder={clearLastReminder}
    renderCard={(reminder, setEditingReminder, clearLastReminder, isLast) => <DocumentReminderRowCard
      key={reminder.reminderNr}
      value={reminder}
      sendMoment={sendMoment}
      isLast={isLast}
      documentLifeCycle={props.document.lifeCycle.value}
      onClearLastReminder={clearLastReminder}
      onReminderEdit={setEditingReminder}
    />}

    deleteAllReminders={deleteAllReminders}
    addReminder={addReminder}
    updateReminder={updateReminder}
    refetch={remindersQuery.refetch}

    canClearAll={canClearAll}
    canDisplayAddNewReminder={canDisplayAddNewReminder}

  />
}